import { render, staticRenderFns } from "./miniarrow.vue?vue&type=template&id=76d830f5&scoped=true&"
var script = {}
import style0 from "./miniarrow.vue?vue&type=style&index=0&id=76d830f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d830f5",
  null
  
)

export default component.exports